<app-strip [data]="dataStrip" [appType]="appType"></app-strip>